import { BodyText } from '@servicetitan/design-system';

interface UserStatusTextProps {
  text: string;
  bold?: boolean;
}

const UserStatusText = ({ text, bold }: UserStatusTextProps) => {
  return (
    <BodyText
      size='xsmall'
      className='m-0 p-r-half'
      bold={bold}
      data-testid='user-status-text'
    >
      {text}
    </BodyText>
  );
};

export default UserStatusText;
